import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VTooltip from 'v-tooltip';
import Clipboard from 'v-clipboard';
import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(Clipboard)
Vue.use(VTooltip)
Vue.use(VueConfirmDialog)

Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.config.productionTip = false

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './registerComponents'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
